import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { colors } from '../../DesignSystem/colors';
import { TYPOGRAPHY } from '../../DesignSystem/typography';
export const InsetShadow = () => (React.createElement("defs", null,
    React.createElement("filter", { id: "inset-shadow" },
        React.createElement("feFlood", { floodColor: "black", floodOpacity: '0.4' }),
        React.createElement("feComposite", { operator: "out", in2: "SourceGraphic" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2" }),
        React.createElement("feComposite", { operator: "atop", in2: "SourceGraphic" }))));
const textStyle = css `
  margin: 0;
  padding: 0;
  font-style: normal;
  font-feature-settings: 'ss02' on, 'ss09' on, 'zero' on;
  display: inline-block;
  text-anchor: middle;
  stroke: none;
`;
export const TitleText = styled.text `
  fill: ${colors.content.onSurface};
  ${textStyle}
  ${TYPOGRAPHY.headline1.desktop}
`;
export const SubtitleText = styled.text `
  fill: ${colors.content.onSurfaceVariant};
  ${textStyle}
  ${TYPOGRAPHY.body1.desktop}
`;
const createAnimation = (circumference, progress) => keyframes `
  from {
    stroke-dashoffset: ${circumference};
  }
  to {
    stroke-dashoffset: ${progress};
  }
`;
export const ProgressCircle = styled.circle `
  stroke-linecap: round;
  stroke-dasharray: ${({ circumference }) => circumference + ' ' + circumference};
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  animation: ${({ circumference, progress }) => createAnimation(circumference, progress)}
    2s cubic-bezier(0.23, 1, 0.32, 1) forwards;
`;
const fadeIn = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const CheckmarkContent = styled.svg `
  animation: ${fadeIn} 2s cubic-bezier(0.23, 1, 0.32, 1) forwards;
`;
const CHECKMARK_SIZE = 10;
export function Checkmark({ x, y }) {
    return (React.createElement(CheckmarkContent, { x: x - CHECKMARK_SIZE, y: y - CHECKMARK_SIZE, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M17.375 5.62539L8.625 14.375L4.25 10.0004", stroke: 'black', "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}
//# sourceMappingURL=ImpProgressRingHelpers.js.map